// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3wy06","title":"header_title__364Np","headerContent":"header_headerContent__3yBts","spacing":"header_spacing__vViqx","headColor":"header_headColor__N_PH5"};